<h2 mat-dialog-title>Envoi et réception eHealthBox</h2>
<mat-dialog-content>
  <div class="panel panel-default ">
        <h3 *ngIf="data.message.document?.title.length !== 0">{{data.message.document.title}}</h3>
        <div *ngIf="data.message.document?.content.length != 0 && data.message.document?.mimetype != 'text/plain' && data.message.document?.mimetype != 'application/pdf'" [ngClass]="" class="panel-body" [innerHTML]="data.message.document?.content"></div>
        <div *ngIf="data.message.document?.content.length != 0 && data.message.document?.mimetype == 'text/plain'" [ngClass]="" class="panel-body"> 
            <textarea style="width:100%;height:30vh;">{{data.message.document.content}}</textarea>
        </div>
        <div *ngIf="data.message.document?.mimetype == 'application/pdf'" [ngClass]="" class="panel-body">
            <div *ngIf="data.message.document?.content.images">
                <div *ngFor="let image of data.message.document.content.images">
                    <img style="width:100%;" [src]="image.url">
                </div>
            </div>
        </div>
        <div *ngIf="data.message.attachments?.length != 0 && data.message.attachments[0].error == false" [ngClass]="" class="panel-body">
          <div *ngFor="let attachment of data.message.attachments">
                <h3 *ngIf="attachment.title?.length !== 0">{{attachment.title}}</h3>
                <div *ngFor="let content of attachment.content">
                    <mat-grid-list cols="3" rowHeight="70px">
                        <mat-grid-tile>
                            <mat-form-field style="width:100%;">
                                <input type="text" placeholder="Patient" aria-label="Patient" matInput (click)="onSelectPatient($event,content);" [formControl]="patientControl" [matAutocomplete]="autoPatient" [disabled]="patient.searchingpatient">
                                <mat-icon *ngIf="patient.searchingpatient" class="fa fa-sync-alt fa-spin fa-fw" matSuffix></mat-icon>
                                <mat-autocomplete #autoPatient="matAutocomplete" [displayWith]="displayPatient">
                                    <mat-option *ngFor="let patient of patientProposition" [value]="patient">
                                        {{patient.firstname}} {{patient.lastname}} {{patient.birthdate}} {{patient.sex}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </mat-grid-tile>
                        <mat-grid-tile>
                            <mat-checkbox class="example-margin" [formControl]="searchReferingControl" [(ngModel)]="userConfig.userSearchOptions.searchreferring">Mes patients</mat-checkbox>
                        </mat-grid-tile>
                        <mat-grid-tile>
                            <mat-form-field style="width:100%;">
                                <mat-label>Sélectionnez la destination de ce message</mat-label>
                                <mat-select [(value)]="selectedDestination" required>
                                    <mat-option value="protocol">Protocole</mat-option>
                                    <mat-option value="labo">Laboratoire</mat-option>
                                    <mat-option value="document">Document</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </mat-grid-tile>
                    </mat-grid-list>
                    <pre *ngIf="attachment.mimetype != 'application/pdf' && attachment.type != 'kmehr'">{{content.text}}</pre>
                    <div *ngIf="content.images">
                        <div *ngFor="let image of content.images">
                            <img style="width:100%;" [src]="image.url">
                        </div>
                    </div>
                    <div *ngIf="content.file">
                        <a style="border:2px solid red; padding: 3px;" target="_blank" href="{{content.file}}">Téléchargez le ficher</a>
                    </div>
                </div>
          </div>
      </div>
      <div *ngIf="data.message.attachments?.length == 0 && data.result.title?.length != 0" [ngClass]="" class="panel-body" [innerHTML]="data.result.title">
    </div>
</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn btn-danger">Fermer</button>
    <button mat-button class="btn btn-success" (click)="startImport()">Récupérer</button>
    <button mat-button class="btn btn-danger" (click)="deleteMessage()">Supprimer</button>
</mat-dialog-actions>